import { isVNode, Fragment, renderSlot, } from 'vue';
export const createRoutesFromChildren = (normalizedChildren) => {
    const routes = [];
    const children = Array.isArray(normalizedChildren)
        ? normalizedChildren
        : normalizedChildren instanceof Object
            ? //normalizedChildren && normalizedChildren.default instanceof Function
                //   ? [normalizedChildren.default()]
                //   : []
                // :
                [renderSlot(normalizedChildren, 'default')]
            : [];
    for (const element of children) {
        if (!isVNode(element)) {
            continue;
        }
        if (element.type === 'template' || element.type === Fragment) {
            routes.push(...createRoutesFromChildren(element.children));
            continue;
        }
        // if (element.type !== Route) {
        //   continue
        // }
        const { path, caseSensitive } = element.props || {};
        const route = {
            path: path || '/',
            caseSensitive: caseSensitive === true,
            element: () => element,
        };
        if (element.children) {
            const childRoutes = createRoutesFromChildren(element.children);
            if (childRoutes.length) {
                route.children = childRoutes;
            }
        }
        routes.push(route);
    }
    return routes;
};
